var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['bg-teal-700 text-white px-1 rounded-md']},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }